import { Link, useLocation } from 'react-router-dom'
import styles from './Header.module.css'

export default function Header() {
  const { pathname } = useLocation()

  if (pathname === '/') return null

  return (
    <header className={styles.minimalHeader}>
      <Link
        to="/"
        state={{ menu: true }}
        className={styles.backToMenu}
        aria-label="Back to menu"
      >
        <img src="/brand/logo dark.svg" alt="MeuView" className={styles.minimalLogo} />
        <span className={styles.backLabel}>
          <span aria-hidden="true">←</span> Back to menu
        </span>
      </Link>
    </header>
  )
}
